'use strict'
// import '@babel/polyfill'
import SmoothScroll from './includes/_SmoothScroll.js'
// import ResizeHelper from './includes/_ResizeHelper.js'
import ScrollHelper from './includes/_ScrollHelper.js'
import Intersection from './includes/_Intersection.js'  
// import ScrollDirectionClass from './includes/_ScrollDirectionClass.js'
// import Slider from './includes/_Slider.js'
// import Sticky from './includes/_Sticky.js'
// import ToggleScrollClass from './includes/_ToggleScrollClass.js'
import anime from 'animejs/lib/anime.es.js'
// import * as PIXI from 'pixi.js'
import Lenis from '@studio-freight/lenis'



// import { Vue, createApp, ref } from 'vue/dist/vue.esm-bundler'
// import { useMediaQuery } from '@vueuse/core'

// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// Swiper.use([Navigation, Autoplay]);
// import 'swiper/css';
// import Intersection from './includes/_Intersection.js'

const BREAK_POINT = 960
const isSP = window.matchMedia(`(max-width: ${BREAK_POINT}px)`)

// window.addEventListener('click', e => {
//   console.log(isSP.matches)
// })



$(() => {
  const $window = $(window)
  const $body = document.querySelector('body')
  $body.classList.add('loaded')

  // dev
  if(location.hash == '#dev') {
    console.warn('dev!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
    document.body.classList.add('dev')
  } else {

    // smooth scroll
    const lenis = new Lenis()
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    
    document.querySelectorAll('a[href *= "#"]').forEach(a => {
      a.addEventListener('click', e => {
        const anchor = new URL(a)
        console.log(anchor.hash)
        lenis.scrollTo(anchor.hash)
      })
    })


  }

  $('.anim-vertscroll').each((index, el) => {
    const direction = $(el).hasClass('anim-vertscroll--reverse') ? -1 : 1
    const offset = direction === -1 ? window.innerWidth : 0
    
    new ScrollHelper(() => {
      const scrolltop = $(window).scrollTop()
      const top = $(el).offset().top
      const speed = .75
      $(el).css('background-position-x',offset -  (scrolltop - top + window.innerHeight) * speed * direction)
      // $('.anim-vertscroll:not(.anim-vertscroll--reverse').css('background-position-x', scrolltop * -speed)
      // $('.anim-vertscroll--reverse').css('background-position-x', scrolltop * speed)
      
    });
  
  })

  
  $('.l-index-what__overlay').each((index, el) => {
    
    // new ScrollHelper(() => {
    // });

    window.addEventListener('scroll', e => {
      if(isSP.matches) {
        const windowCenter = window.innerHeight * 0.5
        const imgH = 290 / window.innerWidth * 50
        const elTop = $(el).offset().top
        const scrolltop = $(window).scrollTop()
        $(el).css('background-position-y', (scrolltop - elTop + windowCenter - imgH))
      }
    })
  
  })


  // rim works dropdown
  $('.js-select-location').on('change', e => {
    location.href = $(e.currentTarget).val()
  })
  $('.js-filter-dropdown').on('click', e => {
    $(e.currentTarget).toggleClass('is-active')
  })
  
  setInterval(e => {
    // $('.js-inview').toggleClass('is-inview')
    // $('body').toggleClass('is-menu-active')
  }, 1000)

  // Intersection Observer
  new Intersection('.js-inview', entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')
      }
    })
  }, {
    root: null,
    rootMargin: "-20% 0px -20% 0px",
    threshold: 0
  })

  function animateSVGStroke(e) {

    const is_dark = e.target.classList.contains('anim-svg--light')
    const is_wait = e.target.classList.contains('anim-svg--home')
    const color = is_dark ? '#fff' : "#000"

    let tl = anime.timeline({
      targets: e.target.querySelectorAll('.anim-svg path'),
      direction: 'normal',
      loop: false
    })

    tl.add({
      easing: 'easeInOutSine',
      stroke: color,
      opacity: [0, 1],
      fill: 'transparent',
      duration: 10,
    }, is_wait ? 800 : 0)
    tl.add({
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      // delay: function(el, i) { return i * 250 },
      duration: 1700
    })
    
    tl.add({
      easing: 'linear',
      fill: ['transparent', color],
      stroke: [color, 'transparent'],
      duration: 500
    }, '-=200')
    

  }



  new Intersection('.js-anim-svg', entries => {
    entries.forEach(entry => {

      if(entry.target.classList.contains('is-once')) {
        return
      }
      if(entry.target.classList.contains('anim-svg--onload')) {
        entry.target.classList.add('is-once')
        animateSVGStroke(entry)
      }

      if (entry.isIntersecting) {
        entry.target.classList.add('is-once')
        // svg animation 
        
        // anime({
        //   targets: '.anim-svg svg path',
        //   strokeDashoffset: [anime.setDashoffset, 0],
        //   easing: 'easeInOutSine',
        //   duration: 3500,
        //   delay: function(el, i) { return i * 250 },
        //   direction: 'alternate',
        //   loop: true
        // });
        animateSVGStroke(entry)

        
      }
    })
  }, {
    root: null,
    rootMargin: "-25% 0px -25% 0px",
    threshold: 0
  })




  // let app = new PIXI.Application({ width: 1640, height: 1360 });

  // document.body.appendChild(app.view);
  // console.log(app)
  // var word = "Hello World!";
  // // var style = {font:'bold 20pt Outfit', fill:'white'};
  // const style = new PIXI.TextStyle({
  //   // fontFamily: "\"Outfit\", cursive"
  //   fontFamily: ['Outfit', 'sans-serif'],
  //   fontSize: 290,
  //   fill:'white'
  // });
  // var textobj = new PIXI.Text(word, style);
  // textobj.position.set(0, 200)

  // setInterval(function(){

  //   var _text = '';
  //   for(var i = 0; i < 230; i++){
  //     _text+= ~~(Math.random() * 10);
  //   }
  //   textobj.text = 'WHAT WE DO';
  // }, 250)
  // console.log(textobj);

  // app.stage.addChild(textobj)



  
  // ヘッダースクロールアクション
  // new ToggleScrollClass();

  
  // // sp menu
  $('.js-toggle-menu').on('click', e => {
    const result = $body.classList.toggle('is-menu-active')

    if(result) {
      document.getElementById('js-menu-scrollelement').scrollTo({top: 0})
    }
    $body.classList.toggle('is-menu-closed', !result)
  })

  $('#js-menu-scrollelement a').on('click', e => {
    const result = $body.classList.remove('is-menu-active')
  })

})


